export function authHeader() {
  // return authorization header with jwt token
  let user = JSON.parse(sessionStorage.getItem('authUser'))
  if (user && user.token) {
    return { Authorization: 'Bearer ' + user.token.access_token }
  } else {
    return {}
  }
}
